import { render, staticRenderFns } from "./TriggerInfoModal.vue?vue&type=template&id=10bea7fc&scoped=true&"
import script from "./TriggerInfoModal.vue?vue&type=script&lang=js&"
export * from "./TriggerInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./TriggerInfoModal.vue?vue&type=style&index=0&id=10bea7fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bea7fc",
  null
  
)

export default component.exports